interface SiteFooterLink {
  label: string;
  url: string;
}

interface SiteFooterLinksProps {
  links: SiteFooterLink[] | undefined | null;
  textColor?: string;
  fontFamily?: string;
}

export default function SiteFooterLinks({
  links,
  textColor = '#000000',
  fontFamily = 'IBM Plex Mono',
}: SiteFooterLinksProps) {
  // No fallback / default links. Only render when the caller provides a non-empty array.
  if (!links || !Array.isArray(links) || links.length === 0) return null;

  const safeLinks = links;

  return (
    <>
      <nav
        className="site-footer-links"
        aria-label="Links do rodapé"
        style={{
          position: 'fixed',
          bottom: 32,
          right: 32,
          textAlign: 'right',
          zIndex: 10,
        }}
      >
        <ul
          style={{
            listStyle: 'none',
            margin: 0,
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            // Same typography tokens as the public menu (applied globally to <body>
            // by NavOverlay from site_settings): font-family, font-size, font-weight,
            // line-height and letter-spacing are inherited, not redefined here.
            fontFamily: `'${fontFamily}', 'IBM Plex Mono', monospace`,
            fontSize: 'inherit',
            fontWeight: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit',
          }}
        >
          {safeLinks.map((link) => (
            <li key={link.url + link.label}>
              <a
                href={link.url}
                target={/^(mailto:|tel:|sms:)/i.test(link.url.trim()) ? undefined : '_blank'}
                rel="noopener noreferrer"
                style={{
                  color: textColor,
                  textDecoration: 'none',
                  fontSize: 'inherit',
                  fontWeight: 'inherit',
                  lineHeight: 'inherit',
                  letterSpacing: 'inherit',
                  transition: 'opacity 0.15s ease',
                  opacity: 1,
                }}

                onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.6')}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
      <style>{`
        @media (max-width: 767px) {
          .site-footer-links {
            position: static !important;
            text-align: left !important;
            margin-top: 48px !important;
            right: auto !important;
            bottom: auto !important;
          }
        }
      `}</style>
    </>
  );
}
